import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import ApiService from "../../../services/api";
import "../css/music_create.css";
import { Editor } from "@tinymce/tinymce-react";
import { EditorInit } from "../../tinymce_editor";

const MusicCreate = () => {
	const hiddenFileInput = React.useRef(null);
	const editorRef = useRef(null);
	const [isDisabledLink, setIsDisabledLink] = useState(true);
	const [isDisabledMusic, setIsDisabledMusic] = useState(true);
	const [errors, setErrors] = useState(false);
	const [Loading, setLoading] = useState(true);
	const [category, setCategory] = useState({});
	const [selectedImage, setSelectedImage] = useState();
	const [formData, setFormData] = useState({
		img: null,
		link: "",
		music_tracks: [],
		videos: "",
		category: "/",
		title: "",
		description: "",
		description_eng: "",
	});

	const fetchCategory = async () => {
		const compositionsCategory = await ApiService.getCategories();
		setCategory(
			compositionsCategory.filter((filter) => filter.type === "music")
		);
		setLoading(false);
	};

	useEffect(() => {
		fetchCategory();
	}, []);

	if (Loading) return;

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === "checkbox" ? checked : value,
		});
	};
	const handleImageChange = (value) => {
		setFormData({ ...formData, img: value });
		if (value) {
			const reader = new FileReader();
			reader.onloadend = () => {
				setSelectedImage(reader.result);
			};
			reader.readAsDataURL(value);
		}
	};
	const handleDragOver = (event) => {
		event.preventDefault();
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const files = event.dataTransfer.files;
		if (!formData.link) {
			handleUploadFile(files);
		}
	};

	const handleClick = () => {
		hiddenFileInput.current.click();
	};

	const handleUploadFile = async (files) => {
		let newFormData = { ...formData };
		let existingFiles = newFormData.music_tracks.map((file) => file.name);
		let duplicateFiles = [];

		Array.from(files).forEach((file) => {
			if (existingFiles.includes(file.name)) {
				duplicateFiles.push(file.name); // Store duplicate file names
			} else {
				newFormData.music_tracks.push({ name: file.name });
			}
		});

		if (duplicateFiles.length > 0) {
			alert(
				`Il file selezionato è già esistente: \n${duplicateFiles.join(", ")}`
			);
			return;
		}

		setFormData(newFormData);

		const updatedTracks = [...newFormData.music_tracks];

		for (let i = 0; i < files.length; i++) {
			let response = await ApiService.uploadFile(files[i]);

			const fileIndex = updatedTracks.findIndex(
				(file, index) =>
					file.name === response.file_name &&
					!file.temp_name &&
					index === newFormData.music_tracks.length - files.length + i
			);

			if (fileIndex !== -1) {
				updatedTracks[fileIndex] = {
					temp_name: response.temp_name,
					name: response.file_name,
					display_name: response.display_name,
				};
			}
		}

		setFormData({ ...newFormData, music_tracks: updatedTracks });
	};

	const handleFileDelete = (temp_name) => {
		let newFormData = { ...formData };
		newFormData.music_tracks = newFormData.music_tracks.filter(
			(file) => file.temp_name !== temp_name
		);
		setFormData(newFormData);
	};

	const handleFileNameChange = (value, index) => {
		let newFormData = { ...formData };
		newFormData.music_tracks[index].display_name = value;
		setFormData(newFormData);
	};

	const handleDescriptionChange = (value) => {
		let newFormData = { ...formData };
		newFormData.description = value;
		setFormData(newFormData);
	};

	const handleDescriptionEngChange = (value) => {
		let newFormData = { ...formData };
		newFormData.description_eng = value;
		setFormData(newFormData);
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (
			!formData.title ||
			formData.category === "/" ||
			(!formData.videos && !formData.music_tracks > 0 && !formData.link) ||
			!formData.img
		) {
			setErrors(true);
			return;
		} else {
			setErrors(false);
		}
		const finalFormData = new FormData();
		Object.entries(formData).forEach(([key, value]) => {
			if (value !== null && value !== undefined) {
				if (Array.isArray(value)) {
					if (key === "music_tracks") {
						finalFormData.append(key, JSON.stringify(value));
					}
				} else if (typeof value === "object" && value !== null) {
					if (value instanceof File) {
						finalFormData.append(key, value);
					}
				} else {
					finalFormData.append(key, value);
				}
			}
		});

		try {
			let result = await ApiService.addMusic(finalFormData);
			if (formData.link) {
				window.location.replace(
					"/compositions/" +
					category
						.filter((filter) => filter.id === Number(formData.category))[0]
						.name.toLowerCase()
				);
			} else {
				window.location.replace(
					"/compositions/" +
					category
						.filter((filter) => filter.id === Number(formData.category))[0]
						.name.toLowerCase() +
					"/" +
					result.slug
				);
			}
		} catch (error) {
			console.error(
				"Errore durante la creazione dell'articolo o il log dell'attività:",
				error
			);
		}
	};

	return (
		<Container fluid className="pt-4 text_data_admin">
			<div>
				<nav aria-label="breadcrumb">
					<ol className="breadcrumb pb-5">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item" aria-current="page">
							<Link to="/admin/musicList">Musica</Link>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							Inserisci contenuto musicale
						</li>
					</ol>
				</nav>
			</div>
			<h1 className="fs-2 text_data_admin form-title">Inserisci contenuto musicale</h1>
			<Row>
				<Col lg="6">
					<label htmlFor="category" className="form-label">
						Categoria *
					</label>
					<select
						value={formData.category}
						className="form-select text_data_admin"
						id="category"
						name="category"
						onChange={handleChange}
					>
						<option value="">- Seleziona categoria -</option>
						{category.map((category) => {
							return (
								<option key={category.id} value={category.id}>
									{category.name}
								</option>
							);
						})}
					</select>
				</Col>
			</Row>
			<Row>
				<Col className="col-12 mt-5">
					<p><strong>Seleziona un'opzione</strong></p>
					<div>
						<input
							type="radio"
							id="radio1"
							name="options"
							value="option1"
							disabled={formData.link}
							className="custom-radio-button me-2"
							onClick={() => {
								setIsDisabledLink(true);
								setIsDisabledMusic(false);
							}}
						/>
						<label htmlFor="radio1">Tracce musicali e video</label>
					</div>

					<div>
						<input
							type="radio"
							id="radio2"
							name="options"
							value="option2"
							disabled={formData.music_tracks.length > 0 || formData.videos}
							className="custom-radio-button me-2 "
							onClick={() => {
								setIsDisabledLink(false);
								setIsDisabledMusic(true);
							}}
						/>
						<label htmlFor="radio2">Link esterno</label>
					</div>
				</Col>
			</Row>
			<Row className="mt-4">
				<Col lg="6" className="py-3">
					<label htmlFor="nameImput" className="form-label">
						Titolo *
					</label>
					<input
						value={formData.title}
						onChange={handleChange}
						type="text"
						className="form-control"
						id="nameImput"
						placeholder="Titolo"
						name="title"
					/>
				</Col>
				<Col lg="6" className="py-3">
					<label htmlFor="nameImputEng" className="form-label">
						Link *
					</label>
					<input
						disabled={
							isDisabledLink ||
							formData.music_tracks.length > 0 ||
							formData.videos
						}
						value={formData.link}
						onChange={handleChange}
						type="url"
						className="form-control"
						id="nameImputEng"
						placeholder="Link"
						name="link"
					/>
				</Col>
				<Row>
					<Col lg="6" className="py-3">
						<label className="form-label">Tracce musicali *</label>
						<Row>
							<Col className="mb-5">
								<div
									className={
										isDisabledMusic || formData.link
											? "file-drop-area-none"
											: "file-drop-area"
									}
									onDragOver={handleDragOver}
									onDrop={handleDrop}
									onClick={
										isDisabledMusic || formData.link ? null : handleClick
									}
								>
									<Button
										disabled={isDisabledMusic || formData.link}
										variant="secondary"
										type="button"
										className="btn btn-sm btn-admin-primary"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											fill="currentColor"
											className="bi bi-plus"
											viewBox="0 0 16 16"
										>
											<path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
										</svg>
										Aggiungi o trascina i file
									</Button>
									<input
										type="file"
										ref={hiddenFileInput}
										onChange={(e) => handleUploadFile(e.target.files)}
										multiple
										style={{ display: "none" }}
									/>
								</div>
							</Col>
						</Row>
						{formData &&
							formData.music_tracks.map((file, index) => (
								<Row
									className="admin-attachments-wrapper my-3"
									key={"key_music_tracks_" + index}
								>
									<Col>
										{file.temp_name ? (
											<input
												type="text"
												className="admin-form mb-3 form-control"
												label="Nome file"
												value={file.display_name}
												onChange={(e) =>
													handleFileNameChange(e.target.value, index)
												}
											/>
										) : (
											"Loading..."
										)}
									</Col>
									<Col>
										{file.temp_name ? (
											<Button
												variant="danger"
												onClick={() => handleFileDelete(file.temp_name)}
												className="text-admin-danger"
											>
												x Rimuovi
											</Button>
										) : (
											""
										)}
									</Col>
								</Row>
							))}
					</Col>
				</Row>
				<Row>
					<Col lg="6" className="pb-3">
						<label htmlFor="videos" className="form-label">
							Link video
						</label>
						<input
							disabled={isDisabledMusic || formData.link}
							value={formData.videos}
							onChange={handleChange}
							type="url"
							className="form-control"
							id="videos"
							placeholder="link video"
							name="videos"
						/>
					</Col>
				</Row>
				<Row>
					<Col>
						<div className="py-3">
							<label htmlFor="image" className="form-label">
								Immagine
							</label>
						</div>
						{selectedImage && (
							<div className="mb-2">
								<img
									src={selectedImage}
									alt="Preview"
									style={{ maxWidth: "100%", maxHeight: "200px" }}
								/>
							</div>
						)}
					</Col>
				</Row>
				<Row>
					<Col>
						<InputGroup className="mb-3">
							<Form.Control
								type="file"
								accept="image/*"
								id="image"
								onChange={(e) => handleImageChange(e.target.files[0])}
								className="form-control"
							/>
							<Button
								variant="secondary"
								id="button-addon2"
								disabled={!selectedImage}
								onClick={() => {
									setFormData({ ...formData, img: "" });
									setSelectedImage(null);
								}}
							>
								Elimina
							</Button>
						</InputGroup>
					</Col>
				</Row>
				<Col lg="12" className="py-3">
					<label htmlFor="description" className="form-label">
						Descrizione
					</label>
					<Editor
						onInit={(evt, editor) => (editorRef.current = editor)}
						value={formData.description}
						onEditorChange={(newContent) => handleDescriptionChange(newContent)}
						tinymceScriptSrc="/tinymce/tinymce.min.js"
						licenseKey="gpl"
						init={EditorInit}
						id="description"
					/>
				</Col>
				<Col lg="12" className="pt-3">
					<label htmlFor="description_eng" className="form-label">
						Descrizione Inglese
					</label>
					<Editor
						onInit={(evt, editor) => (editorRef.current = editor)}
						value={formData.description_eng}
						onEditorChange={(newContent) =>
							handleDescriptionEngChange(newContent)
						}
						tinymceScriptSrc="/tinymce/tinymce.min.js"
						licenseKey="gpl"
						init={EditorInit}
						id="description_eng"
					/>
				</Col>
			</Row>
			<Row className="mt-5">
				<Col>
					{errors && (
						<span style={{ color: "red" }}>Compila i campi obbligatori</span>
					)}
				</Col>
			</Row>
			<Col className="pb-5 text-end d-flex justify-content-start">
				<Button
					className="btn btn-black-gradient text-white"
					onClick={handleSubmit}
					variant="none"
					style={{width: '300px'}}
				>
					Pubblica
				</Button>
			</Col>
		</Container>
	);
};

export default MusicCreate;
